import { createSlice } from '@reduxjs/toolkit'

export const structureCategoryFilterSlice = createSlice({
  name: 'structureCategoryFilter',
  initialState: {
    value: null,
  },
  reducers: {
    setStructureCategoryFilter: (state,action) => {
      state.value = action.payload
    },
    resetStructureCategoryFilter: (state) => {
        state.value = null
    }
  },
})

export const { setStructureCategoryFilter, resetStructureCategoryFilter } = structureCategoryFilterSlice.actions
export default structureCategoryFilterSlice.reducer